import { motion } from "framer-motion"
import styled from "styled-components"

const Inicio = ({ scrollToProductos }) => {
    const scrollToSection = () => {
        scrollToProductos.current?.scrollIntoView({ behavior: 'smooth' });
    };
const heading = "Hi Blinds";
const letterAnimation = {
  hidden: { opacity: 0, y: 20 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.1,
      duration: 0.5,
      ease: "easeOut"
    }
  })
};

    return (
        <>
            <SectionInicio>
            <ImgPresentacionContainer>
            </ImgPresentacionContainer >
                 <h1 className="text-4xl font-bold flex gap-[2px]">
      {heading.split("").map((char, i) => (
        <motion.span
          key={i}
          custom={i}
          variants={letterAnimation}
          initial="hidden"
          animate="visible"
        >
          {char === " " ? "\u00A0" : char}
        </motion.span>
      ))}
    </h1>
                
                    <SobreNosotros>
                        <motion.p 
                         initial={{ opacity: 0, scale: .3, y:30 }}
                animate={{ opacity: 1, scale: 1, y:0 }}
                transition={{
                    duration: 1,
                    scale: { type: "spring", visualDuration: 0.4, bounce: 0.5 },
                }}>
                            Fabrica de persianas con más de 30 años de experiencia.
                        </motion.p>
                    </SobreNosotros>
                <motion.div
                initial={{ opacity: 0, y: 30, scale: .7 }}
                animate={{ opacity: 1, y: 0, scale: 1  }}
                transition={{ duration: 0.5, delay: .2}}
                >
                   <BtnAccionInicio onClick={scrollToSection}>
                        <h3>Ver productos</h3>
                    </BtnAccionInicio>
                </motion.div>
                
            </SectionInicio>
            
        </>
        
     );
}
const SectionInicio = styled.section `
    margin-bottom: 10px;
    height: 100vh;
    position: static;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    h1 {
        position: relative;
        z-index: 20;
        color: #fff;
        text-align: center;
        font-size: 3rem;
    }
`
const ImgPresentacionContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    overflow: hidden;
    z-index: 0;
    background-color: #000f;
`;

const BtnAccionInicio = styled.button `
    background-color: #fff;
    color: #000;
    border: 1px solid #fefeff;
    padding: 10px 30px;
    border-radius: 12px;
    z-index: 10;
    transform: scale(1);
    transition: transform .3s, background .4s;
    margin-top: 10px;

    &:active{
        transform: scale(.7);
    }&:hover{
        background-color: #555555;
    }
    a {
        color: #fff;
        text-decoration: none;
    }
    
`
const SobreNosotros = styled.div `
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    color: #fff;
    z-index: 1;
    margin-bottom: 10px;
    margin-top: -5px;
    p {
        text-align: center;
    }
`
export default Inicio;